import client from '../../client';

const endpoint = '/v2/matching/classifications';


/**
 * Get the classifications from the backend.
 * For more information please read the backend docs.
 */
export function get(params) {
  return client.get(endpoint, { params }).then(({ data }) => data)
}


export default {
  get,
}
